import { APICore } from "./apiCore";

const api = new APICore();

const getPsicologoResponsavel = (paciente_id: string) => {
    return api.get(`/psicologo-responsavel/${paciente_id}`);
};

export { getPsicologoResponsavel };
